import React from 'react';
import { SectionLabelStyled } from './section-label.component.style';
export var SectionLabel = function (_a) {
    var children = _a.children;
    return (React.createElement(SectionLabelStyled, null, children));
};
